import { createSlice } from '@reduxjs/toolkit';

import type { ChartType } from '@/components/Chart/types/highcharts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

import type { PayloadAction } from '@reduxjs/toolkit';

export type ExportState = {
  type: ChartType | ExportTypes.DATA | 'fullscreen';
  isLightMode: boolean;
  from: string | undefined;
};

const initialState: ExportState = {
  type: ExportTypes.DATA,
  isLightMode: false,
  from: undefined
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    setExport: (
      state,
      action: PayloadAction<{
        exportType?: ChartType | 'fullscreen';
        from?: string;
        isLightMode?: boolean;
      }>
    ) => {
      state.type = action.payload.exportType || ExportTypes.DATA;
      state.from = action.payload.from;
      state.isLightMode = action.payload.isLightMode || false;
    }
  }
});

export const { setExport } = exportSlice.actions;
export default exportSlice.reducer;
